import React, { Component, useState } from "react";
import styles from "./css/PropertyManagementDutiesComp.module.css";

const property_duties = [
  {
    bgColor: "#F0FBF4",
    title: "Property Management",
    description: "Property management is the daily oversight of residential, commercial, or industrial real estate",
    icon: "/assets/icons/property-management-duties/Property Management.svg",
  },
  {
    bgColor: "#EDF7FA",
    title: "Leasing",
    description:
      "Property management is the daily oversight of residential, commercial, or industrial real estate",
      icon: "/assets/icons/property-management-duties/Leasing.svg",
  },
  {
    bgColor: "#F4FAEA",
    title: "Mortgage",
    description:
      "Property management is the daily oversight of residential, commercial, or industrial real estate",
      icon: "/assets/icons/property-management-duties/mortgage.svg",
  },
  {
    bgColor: "#F0FCFA",
    title: "Utility Payments",
    description:
      "Property management is the daily oversight of residential, commercial, or industrial real estate",
      icon: "/assets/icons/property-management-duties/Utility Payments.svg",
  },
  {
    bgColor: "#FDEFEF",
    title: "Rent Property",
    description:
      "Property management is the daily oversight of residential, commercial, or industrial real estate",
      icon: "/assets/icons/property-management-duties/Rent Property.svg",
  },
  {
    bgColor: "#F9FAEE",
    title: "Property Inspection",
    description:
      "Property management is the daily oversight of residential, commercial, or industrial real estate",
      icon: "/assets/icons/property-management-duties/Property Inspection.svg",
  },
  {
    bgColor: "#F5F3FE",
    title: "Maintenance Services",
    description:
      "Property management is the daily oversight of residential, commercial, or industrial real estate",
      icon: "/assets/icons/property-management-duties/maintenance.svg",
  },
  {
    bgColor: "#FBEEFE",
    title: "Accounting",
    description:
      "Property management is the daily oversight of residential, commercial, or industrial real estate",
      icon: "/assets/icons/property-management-duties/accounts.svg",
  },
];

export class PropertyManagementDuties extends Component {
  render() {
    return (
      <div className={styles.propertyManagmentDutiescomp}>
        <div className={styles.propertyManagmentDutiescompInner}>
          <div className={styles.topHeading}>
            <div className={styles.headingCont}>
              <h2>Property Management Duties</h2>
            </div>
            <div className={styles.descriptionCont}>
              <p>
                Property management is the daily oversight of residential,
                commercial, or industrial real estate by a third-party
                contractor
              </p>
            </div>
          </div>
          <div className={styles.dutiesList}>
            <div className={styles.dutiesList}>
              <div className={styles.dutiesListInner}>
                {property_duties.map((spec, index) => (
                  <SpecBlocks
                    key={index}
                    spec={spec}
                  ></SpecBlocks>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const SpecBlocks = (props) => {
  const [spec, setSpec] = useState(props.spec);
  return (
    <div className={styles.specBlock}>
      <div className={styles.specBlockInner}>
        <div className={styles.iconCont} style={{backgroundColor: spec["bgColor"]}}>
              <img src={spec["icon"]} />
          
        </div>
        <div className={styles.title}>
          <p>{spec["title"]}</p>
        </div>
        <div className={styles.description}>
          <p>{spec["description"]}</p>
        </div>
      </div>
    </div>
  );
};

export default PropertyManagementDuties;
